<div class="modal-header">
	<h5 class="modal-title">Je wachtwoord opnieuw instellen?</h5>
	<button type="button" class="close" aria-label="Close" (click)="close()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>
<div class="modal-body p-5">
	<section *ngIf="currentUser != false">
		<div class="container">
			<p>Je bent al ingelogd hoor!</p>
		</div>
	</section>
	<section *ngIf="currentUser == false">

		<div class="alert alert-success" *ngIf="successmessage">Er is een e-mail naar <em>{{email}}</em> onderweg met
			een link om je wachtwoord opnieuw in te stellen.</div>

		<div *ngIf="!successmessage">

			<p class="lead">Geen probleem! Vul hieronder je e-mailadres in en dan sturen wij een e-mail met een link om
				je wachtwoord opnieuw in te stellen.</p>

			<div class="form-group">
				<label for="email">Je e-mailadres</label>
				<input type="text" id="email" class="form-control"
					[ngClass]="{ 'is-invalid': errorEmailRequired || errorInvalidEmail || errorInvalidEmailTld , 'is-valid': emailValid }"
					[(ngModel)]="email" (blur)="checkEmail($event)" (keyup.enter)="save()" value="{{email}}" />
				<div *ngIf="errorInvalidEmail || errorEmailRequired" class="invalid-feedback">
					Dit lijkt geen echt e-mailadres te zijn, kijk eens goed.
				</div>
				<div *ngIf="errorInvalidEmailTld" class="invalid-feedback">
					Het lijkt erop dat je een ongeldige domeinnaam hebt ingevoerd. Een e-mailadres eindigt op
					.{{allowedTld.join(', .')}}.
				</div>

				<div *ngIf="errors.email" class="invalid-feedback" style="display:block;">{{errors.email}}</div>
			</div>

			<button (click)="save()" class="btn btn-success">
				<span>Nieuw wachtwoord aanvragen</span>
			</button>

		</div>

		<p class="text-dark mt-5 ">Mocht dat nou niet lukken, vraag dan aan je docent of hij een nieuw wachtwoord voor
			je invult. Komen jullie er nog steeds niet uit? <a href="https://uitgeverijneo.nl/contact" target="_blank">Neem dan contact met
				ons op.</a></p>
	</section>

</div>